import React, { useState, useEffect, useMemo } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, Alert } from 'reactstrap';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { addNewResidueCollected, getResidueCollectedList } from '../../../../slices/thunks';

const ResidueCollectedForm = ({
    dataResidueCollected,
    isOpen,
    handleToggleModal,
    handleResidueCollectedSelectList,
    idsSelectedItem,
    handleIdsSelectedItem
}) => {
    const dispatch = useDispatch();
    const [selectedNormative, handleNormativeSelected] = useState(null);

    const selectorResidueCollected = createSelector(
        state => state.ResidueCollecteds,
        data => ({
            dataList: data.residueCollectedList,
            isLoadingList: data.isLoadingList,
            isResidueCollectedSuccess: data.isResidueCollectedSuccess,
            error: data.error,
            isAdding: data.isAdding,
            isAdded: data.isAdded,
            isAddError: data.isAddError,
            isUpdating: data.isUpdating,
            isUpdated: data.isUpdated,
            isUpdateError: data.isUpdateError,
            isDeleting: data.isDeleting,
            isDeleted: data.isDeleted,
            isDeleteError: data.isDeleteError,
        })
    );

    const { dataList, isLoadingList, isAdding, isUpdating } = useSelector(selectorResidueCollected);
    const [isReportableCheck, setIsReportableCheck] = useState(false);


    const handleIsReportableCheckboxChange = () => {
        setIsReportableCheck(!isReportableCheck);
    };

    const [residueCollectedSelected, setResidueCollectedSelected] = useState([]);
    const [selectionIdsList, setSelectionIdsList] = useState([]);
    const [selectionList, setSelectionList] = useState({});

    // Push all items to handler
    function handlePushItemsSelected() {
        handleResidueCollectedSelectList(residueCollectedSelected);
        handleIdsSelectedItem(selectionList)
    }

    useEffect(() => {
        let selectionItems = [];
        let selectionIdsItems = [];
        if (Object.keys(selectionList).length > 0) {
            Object.entries(selectionList).forEach(([key, value]) => {
                if (key != null) {
                    const item = dataList.find(item => item._id === key);
                    if (item) {
                        selectionItems.push(item);
                    }
                    selectionIdsItems.push(key);
                }
            });
        }
        setResidueCollectedSelected(selectionItems);
        setSelectionIdsList(selectionIdsItems);
    }, [
        selectionList
    ]);

    useEffect(() => {
        if (Object.keys(idsSelectedItem).length === 0) {
            dispatch(getResidueCollectedList(
                {
                    'residue_collected_status_code': 'AVA',
                }
            ));
        }
    }, []);

    useEffect(() => {
        if (selectionIdsList.length > 0) {
            dispatch(getResidueCollectedList(
                {
                    'residue_collected_status_code': 'AVA',
                    'residue_collected_ids': selectionIdsList
                        .map(item => item)
                        .join()
                }
            ));
        }
    }, [selectionIdsList])

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            // normative_id: (dataResidueCollected?._id || ''),
            // residueCollected: values.residueCollected,
            // is_reportable: isReportableCheck
        },
        validationSchema: Yup.object({
            residueCollected: Yup.string().required('Campo requerido'),
            page: Yup.number().typeError('Debe ser un número entero').required('Campo requerido'),
            number: Yup.string().required('Campo requerido'),
        }),
        onSubmit: async (values) => {
            // let residueCollected = await dispatch(addNewResidueCollected(payloadResidueCollected));
        },
    });



    // Delete Data
    const handleClickDelete = residueCollected => {
        setDataResidueCollected(residueCollected);
        setModalDelete(true);
    };

    // Update Data
    const handleClickEdit = residueCollected => {
        setDataResidueCollected(residueCollected);
        handleToggleModal();
    };

    const columns = useMemo(
        () => [

            {
                header: 'Residuo', accessorKey: 'residue.name', size: 'auto',
                Cell: ({ row }) => {
                    return (
                        <div className='no-nowrap'>
                            {row.original.residue.name}
                        </div>
                    );
                },
            },
            { header: 'Kilogramos', accessorKey: 'kilograms', width: 10 },
            { header: 'Fecha', accessorKey: 'beach_cleaning.date', width: 10, dataType: 'date' },
        ],
        [handleClickEdit]
    );

    useEffect(() => {
        console.log('usffct: idsSelectedItem', idsSelectedItem)
        setSelectionList(idsSelectedItem)
    }, [idsSelectedItem])


    return (
        <React.Fragment>

            <Form
                className='tablelist-form'
                onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                }}
            >
                <ModalBody>
                    <Row className='g-3'>

                        <Col lg={12}>
                            <Label for='residueCollected' className='form-label'>
                                Lista de residuos recolectados
                            </Label>
                            <ODataGrid
                                columns={columns}
                                data={dataList || []}
                                getRowIdTable={(originalRow) => originalRow._id}
                                selectAllMode={'all'}
                                selection={{
                                    rowSelection: selectionList,
                                    setRowSelection: setSelectionList,
                                }}
                            />
                        </Col>
                    </Row>
                </ModalBody>

                <div className='modal-footer'>
                    <div className='hstack gap-2 modal-footer-add-btn'>
                        <Button
                            type='button'
                            onClick={() => {
                                handleToggleModal();
                            }} className='btn-danger btn-label'>
                            <i className="icon-x label-icon"></i>
                            Cancelar
                        </Button>
                        <button
                            type='submit'
                            className='btn btn-label btn-primary btn-add-residue'
                            id='add-btn'
                            onClick={() => {
                                handlePushItemsSelected();
                                handleToggleModal();
                            }}
                        >
                            {/* {isAdding || isUpdating ? (
                                <i className="label-icon"><Spinner size='sm' /></i>
                            ) : <i className="ri-save-3-line label-icon"></i>} */}
                            Agregar Residuos Seleccionados
                        </button>
                    </div>
                </div>
            </Form>

        </React.Fragment>
    );
};

export default ResidueCollectedForm;
